import { PhotoDisplayHandler } from "components";
import LinkLanguage from "locales/LinkLanguage";
import "./CategoryItem.scss";

const CategoryItem = ({ item, cat1, cat2, cat3 }: any) => {
  const getName = () => {
    if (cat3 !== undefined) {
      return "nista";
    } else if (cat2 !== undefined) {
      return item.ac_name;
    } else if (cat1 !== undefined) {
      return item.ac_name;
    } else {
      return item.ac_name;
    }
  };
  //todo ne koristi se
  const getDirectory = () => {
    if (cat3 !== undefined) {
      return "products";
    } else if (cat2 !== undefined) {
      return "product_types";
    } else if (cat1 !== undefined) {
      return "categories";
    } else {
      return "categories";
    }
  };

  //samo za prvi nivo kategorija prikazati veliku sliku
  const getLargeImagePath = () => {
    if (cat3 !== undefined) {
      return false;
    } else if (cat2 !== undefined) {
      return false;
    } else if (cat1 !== undefined) {
      return false;
    } else {
      return true;
    }
  };

  const getPath = () => {
    let path = "/articles";
    if (cat3 !== undefined) {
      path += "/" + cat1 + "/" + cat2 + "/" + cat3;
    } else if (cat2 !== undefined) {
      path += "/" + cat1 + "/" + cat2 + "/" + item.slug;
    } else if (cat1 !== undefined) {
      path += "/" + cat1 + "/" + item.slug;
    } else {
      path += "/" + item.slug;
    }
    return path;
  };

  const getEffect = () => {
    const categoryItemName = getName();
    const solarItem = "solarne elektrane";

    if (categoryItemName.toLowerCase().includes(solarItem)) {
      return "Effect";
    }
    return "";
  };

  return (
    <div className="Category-Item">
      <LinkLanguage
        className={`Category-Item-Box Border-${getEffect()}`}
        to={getPath()}
      >
        {/* {item.large_img_path && getLargeImagePath() ? (
          <div className="Main-Category-Item-Icon">
            <PhotoDisplayHandler
              img_name={item.large_img_path}
              // dir={getDirectory()}
              calculate={false}
              img_class_name="MainCategory-Item-Img"
              img_alt={getName()}
              width="auto"
              height="100%"
            />
          </div>
        ) : ( */}
        <>
          <div className="Category-Item-Icon">
            <PhotoDisplayHandler
              img_name={item.img_path}
              // dir={getDirectory()}
              calculate={false}
              img_class_name="Category-Item-Img"
              img_alt={getName()}
              width="auto"
              height=""
            />
          </div>
          <div className="Category-Item-Link">
            <label className={`Text-${getEffect()}`}>{getName()}</label>
          </div>
        </>
        {/* )} */}
      </LinkLanguage>
    </div>
  );
};
export default CategoryItem;
